import { gql } from "apollo-boost";

export const SEND_INVITATION_MUTATION = gql`
  mutation SendInvitation($data: SendInvitationInput!) {
    sendInvitation(data: $data) {
      message
    }
}
`;
